<template>
    <select :name="name" v-bind="properties" v-model="innerValue" class="form-control my-1">
        <option v-for="option in list_options" :value="option.value">{{ option.name }}</option>
    </select>
</template>

<script>
    import ValueForwarder from '~/mixins/value-forwarder'

    export default {
        name: 'ad-select',
        mixins: [
            ValueForwarder,
        ],

        props: {
            name: {
                required: true,
            },

            properties: {
                required: false,
                default: () => {
                    return {};
                },
            },

            options: {
                required: true,
            },
        },

        data() {
            return {
                list_options: {},
            };
        },

        async created() {
            if (this.options.data !== undefined) {
                this.list_options = this.options.data;
            } else if (this.options.url !== undefined) {
                await window.axios.get(this.options.url)
                    .then(({data}) => {
                        this.list_options = data;
                        let valueAsInt = filterInt(this.innerValue);
                        this.innerValue = !isNaN(valueAsInt) ? valueAsInt : this.innerValue;
                    }).catch((error) => {
                        console.log(error);
                    });
            }

            this.list_options = this.rebindNameValue(this.options.nameKey, this.options.valueKey, this.list_options);
        },

        methods: {
            rebindNameValue(nameKey, valueKey, data) {
                for (let d in data) {
                    if (data.hasOwnProperty(d)) {
                        if (nameKey !== undefined) {
                            data[d]['name'] = data[d][nameKey];
                        }

                        if (valueKey !== undefined) {
                            data[d]['value'] = data[d][valueKey];
                        }
                    }
                }

                return _.clone(data);
            },
        },
    };
</script>

<style scoped>

</style>